import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Divider, Select, MenuItem } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import styles from '../GlobalBillingHub.module.scss';
import { getDefaultRelationshipId, getGroupedAgreementOptions } from '../GlobalBillingHub.utils';
export const GlobalBillingHubHeader = (param)=>{
    let { agreements, clientOptions, selectedClient, changeUrlState, groupedOptions, setGroupedOptions, relationshipId } = param;
    const { t: texts } = useLocaleKeys('pages.globalBillingHub.header');
    const { t: gbhTexts } = useLocaleKeys('pages.globalBillingHub');
    const hasAdHoc = groupedOptions.adHocRelationships.length > 0;
    const hasAgreements = groupedOptions.agreements.length > 0;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.filters,
        children: [
            /*#__PURE__*/ _jsx(Autocomplete, {
                freeSolo: true,
                forcePopupIcon: true,
                className: styles.autocomplete,
                testId: "gbh-client",
                options: clientOptions,
                value: selectedClient,
                getOptionLabel: (option)=>option.text,
                textFieldProps: {
                    label: gbhTexts.clientLabel(),
                    placeholder: gbhTexts.chooseClient()
                },
                onChange: (_, newOption)=>{
                    if (!newOption) {
                        changeUrlState({
                            clientId: '',
                            relationshipId: '',
                            selectedDate: ''
                        });
                        setGroupedOptions({
                            agreements: [],
                            adHocRelationships: []
                        });
                    } else if (typeof newOption !== 'string' && !Array.isArray(newOption)) {
                        const newClientId = newOption.id;
                        const grouped = getGroupedAgreementOptions(agreements, newClientId);
                        setGroupedOptions(grouped);
                        changeUrlState({
                            clientId: newClientId,
                            relationshipId: getDefaultRelationshipId([
                                ...grouped.agreements,
                                ...grouped.adHocRelationships
                            ]),
                            selectedDate: ''
                        });
                    }
                }
            }),
            relationshipId && /*#__PURE__*/ _jsxs(Select, {
                collapseHelperText: false,
                width: 400,
                label: texts.agreementLabel(),
                testId: "gbh-relationship",
                value: relationshipId,
                menuMaxHeight: 400,
                placeholder: texts.noAgreements(),
                onChange: (e)=>changeUrlState({
                        relationshipId: e.target.value,
                        selectedDate: ''
                    }),
                children: [
                    groupedOptions.agreements.map((param, idx)=>{
                        let { id, text } = param;
                        return /*#__PURE__*/ _jsx(MenuItem, {
                            value: id,
                            testId: "gbh-relationship-opt-".concat(idx),
                            children: text
                        }, id);
                    }),
                    hasAgreements && hasAdHoc && /*#__PURE__*/ _jsx(Divider, {
                        margin: 8
                    }),
                    groupedOptions.adHocRelationships.map((param, idx)=>{
                        let { id } = param;
                        return /*#__PURE__*/ _jsx(MenuItem, {
                            value: id,
                            testId: "gbh-relationship-adhoc-".concat(idx),
                            children: texts.invoicesWithoutAgreement()
                        }, id);
                    })
                ]
            })
        ]
    });
};
